export default __webpack_public_path__ + "img/63373d42ef15b44f38ce44a34ff365f5.svg";